// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    resourceId: z.string().min(1).max(21),
    name: z.string().min(1).max(256),
    description: z.string().min(1),
    createdAt: z.number().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    resourceId: z.string().min(1).max(21),
    name: z.string().min(1).max(256),
    description: z.string().min(1),
    createdAt: z.number(),
});
export const Scopes = Object.freeze({
    table: 'scopes',
    tableSingular: 'scope',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        resourceId: 'resource_id',
        name: 'name',
        description: 'description',
        createdAt: 'created_at',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'resourceId',
        'name',
        'description',
        'createdAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
